
import React from "react";
import "./watermark.css";

const Watermark = ({theme}) => {
  const rows = Array.from({ length: 10 });

  return (
     <div className={`intermittent-watermark ${theme || ''}`}>
      <div className="watermark-grid">

        {rows.map((_, rowIndex) => (
          <div className="watermark-row" key={rowIndex}>
            {Array.from({ length: 6 }).map((_, index) => (
              <span key={index}>
                Aamantran Trial
              </span>
            ))}
          </div>
        ))}

      </div>
    </div>
  );
};

export default Watermark;